<template>
	<div class="binding-body">
		<div class="search-box">
			<div class="input-box" style="width: 280px;">
				<el-select v-model="selectType" class="select-box" size='small' @change="selectTypeHandle">
					<template v-for="(item) in selectList">
						<el-option :value="item.value" :label="item.label" :key="item.value"></el-option>
					</template>
				</el-select>
				<el-input
					v-model="productName"
					v-if="selectType === '0'"
					placeholder="请输入商品名称"
					class="name-input"
					size="small"
					@keyup.enter.native="search"
				></el-input>
				<el-input
					v-model="attrplanName"
					v-if="selectType === '1'"
					placeholder="请输入规格"
					class="name-input"
					size="small"
					@keyup.enter.native="search"
				></el-input>
				<el-input
					v-model="productCode"
					v-if="selectType === '2'"
					placeholder="请输入商品编号"
					class="name-input"
					size="small"
					@keyup.enter.native="search"
				></el-input>
			</div>
			<div class="input-box">
				<span>启用状态：</span>
				<el-select v-model="useStatus" class="select-box" size='small'>
					<el-option :value="-1" label="全部"></el-option>
					<el-option :value="0" label="启用"></el-option>
					<el-option :value="1" label="禁用"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>可售状态：</span>
				<el-select v-model="saleStatus" class="select-box" size='small'>
					<el-option :value="-1" label="全部"></el-option>
					<el-option :value="0" label="可售"></el-option>
					<el-option :value="1" label="停售"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>店铺级大类：</span>
				<el-select v-model="bcId" class="select-box" size='small' @change="bcChange">
					<el-option value="0" label="全部"></el-option>
					<template v-for="(item) in bc">
						<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id"/>
					</template>
				</el-select>
			</div>
			<div class="input-box" v-if="bigcategoryview === 1">
				<span>店铺级小类：</span>
				<el-select v-model="scId" class="select-box" size='small'>
					<el-option value="0" label="全部"></el-option>
					<template v-for="(item) in sc">
						<el-option :value="item.id" :label="item.name" :key="item.id"></el-option>
					</template>
				</el-select>
			</div>
			<div class="input-box-btn">
				<el-button
					type="primary"
					class="search-btn"
					size="small"
					plain
					@click="search">查询</el-button>
			</div>
		</div>
        <div class="table-box">
            <el-table
				:stripe='true'
				size='mini'
				ref='multipleTable'
				class="grid-content"
				:data="tableData"
				:height="tableHeight"
				border
				@selection-change="handleSelectionChange">
				<el-table-column
				type="selection"
				align="center"
				width="55">
				</el-table-column>
				<el-table-column
					label-class-name = "column-index"
					label="序号"
					type="index"
					width="70"
					align="center">
				</el-table-column>
				<el-table-column
						prop="productname"
						label="商品名称"
						align="center"
						min-width="180">
					</el-table-column>
					<el-table-column
						prop="productcode"
						label="商品编号"
						align="center"
						min-width="160">
					</el-table-column>
					<el-table-column
						prop="spec"
						label="规格"
						align="center"
						min-width="100">
					</el-table-column>
					<el-table-column
						prop="inventory"
						label="当前库存"
						align="center"
						min-width="100">
						<template slot-scope="scope">
							<el-input
							class="num-input"
								v-if="scope.row.showInput"
								v-model="scope.row.inventory"
								size="small"
								@input="numInput(scope.row)"
								@blur="numBlur(scope.row)"
							></el-input>
							<span v-else :class="scope.row.inventory === 0?'active':''">{{scope.row.inventory}}</span>
						</template>
					</el-table-column>
					<el-table-column
					prop="disabledflag"
					label="启用状态"
					align="center"
					min-width="100">
					<template slot-scope="scope">{{ scope.row.disabledflag ? '禁用' : '启用' }}</template>
					</el-table-column>
					<el-table-column
					prop="plandisabledflag"
					label="可售状态"
					align="center"
					min-width="100">
					<template slot-scope="scope">{{ scope.row.plandisabledflag ? '停售' : '可售' }}</template>
					</el-table-column>
					<el-table-column
						prop="bbcname"
						label="店铺级大类"
						align="center"
						min-width="100">
					</el-table-column>
					<el-table-column
						v-if="bigcategoryview === 1"
						prop="sbcname"
						label="店铺级小类"
						align="center"
						min-width="100">
					</el-table-column>
					<!-- <el-table-column
						prop="pavname"
						label="商品单位"
						align="center"
						min-width="100">
					</el-table-column> -->
			</el-table>
        </div>
        <div class="page-box">
				<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="page.number"
				:page-sizes="[20,40, 60, 100]"
				:page-size="page.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
        <div class="binding-foot">
            <el-button class="btn" plain type="primary" @click="cancelClick">取消</el-button>
            <el-button class="btn" plain type="primary" @click="saveClick">保 存</el-button>
        </div>
	</div>
</template>
<script>
export default {
	name: 'setMuti',
	props: {
		sessionStoreId: String,
		show: Boolean
	},
	data () {
		return {
			bc: [],
			sc: [],
			shopId: '',
			bcId: '0',
			scId: '0',
			auditState: 4,
			productName: '',
			attrplanName: '',
			productCode: '',
			tableData: [],
			total: 0,
			page: {
				number: 1,
				size: 20
			},
			isCheck: [],
			tableHeight: '100%',
			bigcategoryview: 0,
			selectList: [
				{ value: '0', label: '商品名称' },
				{ value: '1', label: '规格' },
				{ value: '2', label: '商品编号' }
			],
			selectType: '0',
			useStatus: -1,
			saleStatus: -1
		}
	},
	watch: {
		show: {
			handler (val) {
				if (val === true) {
					this.shopId = this.sessionStoreId
					this.getBigCategory()
					if (this.bigcategoryview === 1) {
						this.getSmalCategory()
					}
					this.search()
				} else {
					this.tableData = []
					this.productName = ''
					this.bcId = '0'
					this.scId = '0'
					this.auditState = 4
				}
			},
			immediate: true
		}
	},
	created () {
		this.checkSmallCategory().then(res => {
			this.bigcategoryview = res.bigcategoryview
		})
	},
	methods: {
		// 是否开启小类
		checkSmallCategory () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					resolve(res)
				})
			})
		},
		handleSelectionChange (val) {
			this.isCheck = val
			let list = this.tableData
			for (let i = 0; i < list.length; i++) {
				list[i].showInput = false
			}
			for (let i = 0; i < val.length; i++) {
				val[i].showInput = true
			}
		},
		numBlur (data) {
			if (data.inventory === '' || data.inventory === null) {
				data.inventory = 0
			}
		},
		numInput (data) {
			let inventory = data.inventory.replace(/[^\d-]/g, '')
			if (inventory.lastIndexOf('-') > -1) {
				let numArr = inventory.split('')
				numArr.splice(inventory.lastIndexOf('-'), 1)
				inventory = numArr.join('')
			}
			// 最多输入位数
			// if (num.indexOf('-') > -1) {
			// 	num = +num.slice(0, 5)
			// } else {
			// 	num = +num.slice(0, 4)
			// }
			if (inventory !== '' && inventory !== null) {
				data.inventory = +inventory
			} else {
				data.inventory = ''
			}
		},
		bcChange (value) {
			this.scId = '0'
			this.bcId = '' + value
			this.getSmalCategory()
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
					this.getSmalCategory()
				}
			})
		},
		getSmalCategory () {
			let params = {
				pid: this.bcId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		tableReload () {
			let params = {
				shopid: this.shopId,
				productName: this.productName,
				attrplanName: this.attrplanName,
				productCode: this.productCode,
				bigTypeCategory: this.bcId ? this.bcId : '0',
				smallTypeCategory: this.scId ? this.scId : '0',
				disabledflag: this.useStatus,
				planDisabledflag: this.saleStatus,
				page: this.page.number,
				size: this.page.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/product/getProductInfo4Inventory`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.tableData = res.data.recordList
					this.total = res.data.recordCount
					this.$refs.multipleTable.doLayout()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		search () {
			this.page.number = 1
			this.tableReload()
		},
		cancelClick () {
			this.resetSearch()
			this.$emit('update:show', false)
		},
		resetSearch () {
			this.selectType = '0'
			this.useStatus = -1
			this.saleStatus = -1
			this.productName = ''
			this.attrplanName = ''
			this.productCode = ''
		},
		saveClick () {
			let list = this.tableData
			let checkList = []
			for (let i = 0; i < list.length; i++) {
				if (list[i].showInput) {
					let param = {
						id: list[i].paid,
						inventory: list[i].inventory
					}
					checkList.push(param)
				}
			}
			if (checkList.length === 0) {
				this.$message.error('请选择商品')
			} else {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/product/inventory/update`,
					data: checkList
				}).then(res => {
					if (res.result === true) {
						this.$message.success('本页勾选数据进行保存成功！')
						this.tableReload()
					} else {
						this.$message.error(res.msg)
					}
				})
			}
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		},
		selectTypeHandle (val) {
			this.productName = ''
			this.productCode = ''
			this.attrplanName = ''
		}
	}
}
</script>
<style lang="stylus" scoped>

.binding-body{
    display: flex;
    width :100%;
	flex-direction: column;
    height :400px;
    overflow-y :auto;
	.search-box{
		margin-bottom :10px;
		width:100%;
		height :40px;
		line-height :40px;
		display:flex;
		flex-wrap:wrap;
		.input-box-btn{
			width :80px;
		}
		.input-box{
			margin-left :10px;
			width :220px;
			margin-bottom:10px
			.name-input {
				width: 130px;
				margin-right: 10px;
			}
			.select-box{
				width:120px;
				margin-right:10px;
			}
		}
	}
    .table-box{
		width :100%;
        padding-bottom :10px;
        height:250px;
		.num-input >>> .el-input__inner{
			height:23px !important;
			line-height:23px !important;
		}
    }
    .page-box{
        text-align :center
    }
    border-radius :0px 0px 10px 10px;
    .btn-box{
        width :90%;
        padding :10px;
        text-align :left
    }
    .binding-foot{
        position: relative;
        height :40px;
		margin-top:10px;
        width :100%
        .btn{
            width :35%;
			margin-left:95px;
        }
    }
}
.filter-input {
	width: 100px;
}
.active {
	color: #f85050;
}

</style>
<style lang="stylus">
.binding-body {
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
